import { Map, List } from 'immutable';

import { prepareBuildsData } from '../../../../util';

export const createBuildsReducer = (types) => {
  const initialState = Map({
    loading: false,
    selectedStatus: null,
    builds: List(),
    testsByBuild: List(),
    testsWithoutBuild: List(),
    hasMoreTests: false,
    totalTests: 0,
    currentPage: 1,
  });

  const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case types.GET_BUILDS_TESTS.REQUEST:
        return state.set('loading', true);
      case types.GET_BUILDS_TESTS.SUCCESS: {
        const { builds, tests_missing_build: testsMissingBuild } = payload;
        const testsWithoutBuildItems = testsMissingBuild && Array.isArray(testsMissingBuild.items) ?
          testsMissingBuild.items : [];
        return state.withMutations((newState) => {
          newState
            .set('loading', false)
            .set('builds', List(prepareBuildsData(builds.items)))
            .set('testsWithoutBuild', List(testsWithoutBuildItems))
            .set('hasMoreTests', testsMissingBuild.has_more)
            .set('totalTests', testsMissingBuild.total)
            .set('currentPage', 1);
        });
      }
      case types.GET_TESTS_BY_BUILD.SUCCESS:
        return state.set('testsByBuild', List(payload.items));
      case types.SET_TESTS_BY_BUILD:
        return state.set('testsByBuild', payload);
      case types.GET_TESTS_BY_BUILD.FAILURE:
      case types.GET_BUILDS_TESTS.FAILURE:
      case types.GET_TESTS.FAILURE:
        return initialState;
      case types.GET_TESTS.SUCCESS: {
        const { items, has_more: hasMore } = payload;
        return state.withMutations((newState) => {
          newState
            .set('loading', false)
            .set('testsWithoutBuild', List(items))
            .set('hasMoreTests', hasMore);
        });
      }
      case types.SET_STATUS_FILTER:
        return state.set('selectedStatus', payload);
      case types.SET_CURRENT_PAGE:
        return state.set('currentPage', payload);
      case types.CLEAN_UP:
        return initialState;
      default:
        return state;
    }
  };
  return { reducer, initialState };
};
